module.exports = __webpack_public_path__ + "img/audit.66a224f1.svg";